export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/icon_notification-2fb055f761009e64bb003639d5c60819.svg";